export const iconFontAwesomeHumanitarianPeopleLine = (
	<i className="fa-solid fa-people-line"></i>
);
